var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshCw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3335 6.6665V16.6665H28.3335",
    stroke: "#0AAD0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 33.3335V23.3335H11.6665",
    stroke: "#0AAD0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84984 15C6.69512 12.6113 8.13173 10.4756 10.0256 8.79233C11.9195 7.10902 14.2089 5.9329 16.6803 5.37373C19.1517 4.81455 21.7244 4.89053 24.1585 5.59459C26.5925 6.29864 28.8086 7.60782 30.5998 9.39996L38.3332 16.6666M1.6665 23.3333L9.39984 30.6C11.1911 32.3921 13.4071 33.7013 15.8412 34.4053C18.2752 35.1094 20.848 35.1854 23.3194 34.6262C25.7907 34.067 28.0802 32.8909 29.9741 31.2076C31.8679 29.5243 33.3046 27.3887 34.1498 25",
    stroke: "#0AAD0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw);
export default __webpack_public_path__ + "static/media/refresh-cw.d663d4fbc24f15adb46efb842329dc7a.svg";
export { ForwardRef as ReactComponent };